import React, {useEffect, useState} from 'react';

interface Props {
    recordUrl:any
}
const AudioInput = (props:Props) => {
    const { recordUrl } = props;
    const [uniqueKey, setUniqueKey] = useState(Date.now());

    useEffect(() => {
        // Update the unique key to trigger re-render
        setUniqueKey(Date.now());
    }, [recordUrl]);

    return (
        <div>
            {recordUrl && (
                <audio controls key={uniqueKey}>
                    <source src={URL.createObjectURL(recordUrl)} type={recordUrl.type} />
                    Your browser does not support the audio element.
                </audio>
            )}
        </div>
    );
};

export default AudioInput;
